export const getLockStatusNote = (statusValue) => {
    const raw = (statusValue ?? '').toString().trim();

    const statusMap = {
        "Active Request":
            "Initial lock request submitted. Once it is processed by the Lock Desk, disclosures will be enabled.",
        "Denied":
            "Lock request was denied by the Lock Desk. Please review the details and resubmit if necessary.",
        "Lock Expired":
            "The current lock period has expired. A new lock request must be submitted to proceed.",
        "":
            "Lock is not requested. Once requested and processed by the Lock Desk, disclosures will be enabled.",
    };

    const matchedStatus = Object.entries(statusMap).find(
        ([key]) => key.toLowerCase() === raw.toLowerCase()
    );

    return (
        matchedStatus?.[1] ||
        "Lock is not requested. Once requested and processed by the Lock Desk, disclosures will be enabled."
    );
};

export const isPollyProcessingStatus_OLD = (lockStatusValue, field1401Value, loanType) => {
    const loan = (loanType ?? '').trim();
    const field1401 = (field1401Value ?? '').trim();
    const lockStatus = (lockStatusValue ?? '').trim().toLowerCase();

    // Skip when loan type is missing or Business, or when 1401 field is empty
    if (!loan || loan === 'Business' || !field1401) return false;

    const pollyProcessingStatuses = ["Active Request", "Denied", "Lock Expired", ""];
    return pollyProcessingStatuses.some(status => status.toLowerCase() === lockStatus);
};

export const isPollyProcessingStatus = (lockStatusValue, field1401Value, loanType) => {
    const loan = (loanType ?? '').trim();
    const field1401 = (field1401Value ?? '').trim();
    const lockStatus = (lockStatusValue ?? '').trim().toLowerCase();

    // If no loan type or 1401 program exists, treat as Allow
    if (!loan || !field1401) return false;

    const isBusiness = loan === 'Business';
    const deniedOrExpired = ['denied', 'lock expired'];

    // --- Consumer Purpose ---
    if (loan === 'Consumer') {
        // Float: empty status + 1401 exists -> Allow
        if (!lockStatus && field1401) return false;

        // Active Request -> Don't Allow
        if (lockStatus === 'active request') return true;

        // Locked -> Allow
        if (lockStatus === 'locked') return false;

        // Denied / Lock Expired -> Don't Allow
        if (deniedOrExpired.includes(lockStatus)) return true;

        // Anything else -> Allow
        return false;
    }

    // --- Business Purpose ---
    if (isBusiness) {
        // Float: empty status + 1401 exists -> Allow
        if (!lockStatus && field1401) return false;

        // Active Request -> Allow
        if (lockStatus === 'active request') return false;

        // Locked -> Allow
        if (lockStatus === 'locked') return false;

        // Denied / Lock Expired -> Don't Allow
        if (deniedOrExpired.includes(lockStatus)) return true;

        // Anything else -> Allow
        return false;
    }

    // Default fallback -> Allow
    return false;
};
